export default class CurrentUser {
  isLoggedIn = false;
  expiry = null;
  id = null;
  username = null;
  company = null;
  roles = null;
  provider = "";
  constructor(
    isLoggedIn,
    expiry,
    id,
    username,
    company,
    roles,
    provider,
  ) {
    this.isLoggedIn = isLoggedIn;
    this.expiry = expiry;
    this.id = id;
    this.username = username;
    this.company = company;
    this.roles = roles;
    this.provider = provider;
  }
}
